import { baseApi } from "./baseApi";

const CONTRACTOR_USER_BASE_URL = "/contractorUser";

export const contractorUserApi = baseApi.injectEndpoints({
  tagTypes: ["ContractorUser"],
  endpoints: (builder) => ({
    getContractorUserListData: builder.query({
      query: (params) => ({
        url: `${CONTRACTOR_USER_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ContractorUser",
                id: _id,
              })),
              { type: "ContractorUser", id: "LIST" },
            ]
          : [{ type: "ContractorUser", id: "LIST" }],
    }),

    createContractorUserData: builder.mutation({
      query: (payload) => ({
        url: `${CONTRACTOR_USER_BASE_URL}/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "ContractorUser", id: "LIST" }],
    }),

    getContractorUserDataDetail: builder.query({
      query: (id) => `${CONTRACTOR_USER_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "ContractorUser", id },
        { type: "ContractorUser", id: "LIST" },
      ],
    }),

    updateContractorUserData: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${CONTRACTOR_USER_BASE_URL}/${_id}`,
          method: "PUT",
          body: {
            ...body,
            typeRefSource: "Contractor", 
          },
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "ContractorUser", id: _id },
        { type: "ContractorUser", id: "LIST" },
      ],
    }),

    getDDLContractorUserList: builder.query({
      query: () => `${CONTRACTOR_USER_BASE_URL}/ddl`,
    }),
  }),
});

export const {
  useGetContractorUserListDataQuery,
  useLazyGetContractorUserListDataQuery,
  useLazyGetDDLContractorUserListQuery,
  useCreateContractorUserDataMutation,
  useGetContractorUserDataDetailQuery,
  useUpdateContractorUserDataMutation,
} = contractorUserApi;
